export class UserFriendlyError extends Error {

}